export class Pagination {
  constructor(public page: number, public previousPage: number, public predicate: string, public reverse: any) {
    this.page = !this.page ? 1 : this.page;
    this.previousPage = !this.previousPage ? 1 : this.previousPage;
  }
}
